export const customtableStyles = {
  headRow: {
    style: {
      borderRadius: "30px",
      backgroundColor: "var(--table-header)",
      color: "var(--text-color)",
      fontWeight: "bold",
    },
  },
  headCells: {
    style: {
      fontSize: "14px",
      color: "white",
      margin: "0px",
    },
  },

  rows: {
    style: {
      borderRadius: "30px",
      color: "var(--text-color)",
      height: "60px",
      "&:nth-child(2n)": {
        backgroundColor: "var(--row-color)",
      },
      "&:hover": {
        // cursor: "pointer",
      },
    },
  },
};

export const conditionalRowStyles = [
  {
    when: (row) => row,
    style: {
      "&:hover": {
        cursor: "pointer",
        color: "var( --active-border)",
      },
    },
  },
];

export const custombatsmanbowlertableStylesExpandable = {
  headRow: {
    style: {
      // height: "0px",
      // minHeight: "0px",
      // maxHeight: "0px",
      // padding: "0px",
      // border: "none",
      // visibility: "hidden",
      display: "none",
    },
  },
  headCells: {
    style: {
      // height: "0px",
      // minHeight: "0px",
      // maxHeight: "0px",
      // padding: "0px",
      // border: "none",
      // visibility: "hidden",
      display: "none",
    },
  },
  rows: {
    style: {
      color: "#22242C",
      height: "48px",
      borderBottom: "1px solid #E2E2E2",
      "&:hover": {
        cursor: "pointer",
      },
      backgroundColor: "var(--row-color)",
    },
  },
  cells: {
    style: {
      paddingLeft: "0px", // Align with outer table columns
    },
  },
};
